export const SET_USER = "SET_USER",
  REMOVE_USER = "REMOVE_USER",
  SET_REFERRER = "SET_REFERRER",
  SET_ANSWER = "SET_ANSWER";